import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ownershipTypeScpiOptions } from '@app/forms/subscription/services/ref';

import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'ownership-type-scpi',
    templateUrl: './ownership-type-scpi.component.html',
    styleUrls: ['./ownership-type-scpi.component.scss'],
    standalone: false
})
export class OwnershipTypeScpiComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = ownershipTypeScpiOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
